var React = require('react');

function ArrowLeftInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M32.4614 9.49425C31.7426 8.83525 30.577 8.83525 29.8581 9.49425L15.5398 22.6197C15.1301 22.9952 14.9539 23.5038 15.0112 23.9938C14.9495 24.4875 15.1252 25.0014 15.5383 25.3801L29.8566 38.5056C30.5755 39.1646 31.7411 39.1646 32.46 38.5056C33.1789 37.8466 33.1789 36.7781 32.46 36.1191L19.24 24.0006L32.4614 11.8807C33.1803 11.2217 33.1803 10.1532 32.4614 9.49425Z"}));
}

ArrowLeftInline.defaultProps = {"className":"w-full h-full fill-white","viewBox":"0 0 48 48"};

module.exports = ArrowLeftInline;

ArrowLeftInline.default = ArrowLeftInline;
